// @flow
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ArrowLeft } from '@finect/tabular-icons/arrowLeft';

const BackNavigation = styled.nav`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  height: 33px;
  padding-left: 30px;
  margin-bottom: 24px;
  font-weight: 500;

  svg {
    position: absolute;
    top: 6px;
    left: 0;
    margin-right: 6px;
  }
`;

const BackLink = styled(AppLink)`
  cursor: pointer;
`;

type Props = {
  fromApp?: boolean,
  text?: string,
  backPath?: string,
  children?: any,
  goBack?: Function
};

export const Navigation = ({ text, fromApp, backPath, goBack, children }: Props) => (
  <BackNavigation>
    {fromApp && !backPath ? (
      <BackLink onClick={goBack} as={'div'}>
        <ArrowLeft size="22" /> {text || 'Ver todas las preguntas'}
      </BackLink>
    ) : (
      <AppLink
        as={Link}
        to={{
          pathname: backPath || '/preguntas',
          state: { forceFetch: true }
        }}
      >
        <ArrowLeft size="22" /> Ver todas las preguntas
      </AppLink>
    )}
    {children}
  </BackNavigation>
);
